// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1-pu2","tab":"ProcedureTabs_tab__2jevj"};